import _regeneratorRuntime from "@babel/runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

import { getValue, getText } from './helpers.js';

var MultipleSelect = /*#__PURE__*/function () {
  function MultipleSelect(autocomplete) {
    _classCallCheck(this, MultipleSelect);

    this.autocomplete = autocomplete;
    this.selectedValues = new Set();
    this.defaultSelectedValues = [];
    this.autocomplete = autocomplete;
  }

  _createClass(MultipleSelect, [{
    key: "connected",
    value: function connected() {
      var _this = this;

      var values = parseJSON(this.autocomplete.value);
      values.forEach(function (value) {
        return _this.selectedValues.add(value);
      });
      this.defaultSelectedValues = this.persistedTags.map(function (tag) {
        return {
          value: getValue(tag),
          text: getText(tag)
        };
      });
    }
  }, {
    key: "disconnected",
    value: function disconnected() {//
    }
  }, {
    key: "start",
    value: function start() {
      var _iterator = _createForOfIteratorHelper(this.autocomplete.options),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var option = _step.value;

          if (this.selectedValues.has(getValue(option))) {
            this.autocomplete.combobox.select(option);
          } else {
            this.autocomplete.combobox.deselect(option);
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }, {
    key: "stop",
    value: function stop() {
      this.clearInputField();
    }
  }, {
    key: "commit",
    value: function () {
      var _commit = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(option) {
        var value, text, activeOption, _iterator2, _step2, _option, _iterator3, _step3, group;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.clearInputField();
                value = getValue(option);
                text = getText(option);

                if (this.selectedValues.has(value)) {
                  this.removeValue(value);
                } else {
                  this.setValue(value, text);
                }

                if (!this.autocomplete.src) {
                  _context.next = 12;
                  break;
                }

                _context.next = 7;
                return this.autocomplete.makeRequest('');

              case 7:
                // Select the options and activate the most viable option.
                this.start();
                activeOption = this.autocomplete.visibleOptions.find(function (o) {
                  return getValue(o) === value;
                }) || this.autocomplete.visibleOptions[0];

                if (activeOption) {
                  this.autocomplete.activate(activeOption);
                }

                _context.next = 16;
                break;

              case 12:
                _iterator2 = _createForOfIteratorHelper(this.autocomplete.options);

                try {
                  for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                    _option = _step2.value;
                    _option.hidden = false;
                  }
                } catch (err) {
                  _iterator2.e(err);
                } finally {
                  _iterator2.f();
                }

                _iterator3 = _createForOfIteratorHelper(this.autocomplete.groups);

                try {
                  for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                    group = _step3.value;
                    group.hidden = false;
                  }
                } catch (err) {
                  _iterator3.e(err);
                } finally {
                  _iterator3.f();
                }

              case 16:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function commit(_x) {
        return _commit.apply(this, arguments);
      }

      return commit;
    }()
  }, {
    key: "clear",
    value: function clear() {
      var _this2 = this;

      this.selectedValues.forEach(function (value) {
        return _this2.removeValue(value);
      });
    }
  }, {
    key: "reset",
    value: function reset() {
      var _this3 = this;

      this.clear();
      this.defaultSelectedValues.forEach(function (_ref) {
        var value = _ref.value,
            text = _ref.text;
        return _this3.setValue(value, text, {
          persisted: true
        });
      });
    }
  }, {
    key: "setValue",
    value: function setValue(value, text) {
      var _ref2 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
          _ref2$persisted = _ref2.persisted,
          persisted = _ref2$persisted === void 0 ? false : _ref2$persisted;

      if (this.selectedValues.has(value)) return;
      this.selectedValues.add(value);
      this.insertTag(value, text, {
        persisted: persisted
      });
      this.updateElementValue();
      this.setRequiredAttribute(this.autocomplete.required); // Only select if the listbox is open because all options are deselected when it is hidden.

      if (this.autocomplete.open) {
        var option = this.autocomplete.options.find(function (option) {
          return getValue(option) === value;
        });

        if (option) {
          this.autocomplete.combobox.select(option);
        }
      }
    }
  }, {
    key: "removeValue",
    value: function removeValue(value) {
      if (!this.selectedValues.has(value)) return;
      this.selectedValues.delete(value);
      this.removeTag(value);
      this.updateElementValue();
      this.setRequiredAttribute(this.autocomplete.required);
      var option = this.autocomplete.options.find(function (option) {
        return getValue(option) === value;
      });

      if (option) {
        this.autocomplete.combobox.deselect(option);
      }
    }
  }, {
    key: "setRequiredAttribute",
    value: function setRequiredAttribute(value) {
      if (!value || value && this.selectedValues.size > 0) {
        this.autocomplete.input.required = false;
        return;
      }

      this.autocomplete.input.required = true;
    }
  }, {
    key: "insertTag",
    value: function insertTag(value, text) {
      var _ref3 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
          _ref3$persisted = _ref3.persisted,
          persisted = _ref3$persisted === void 0 ? false : _ref3$persisted;

      var templateClone = this.template.content.cloneNode(true);
      var tagField = templateClone.querySelector('[data-behavior="tag"]');
      var tagText = templateClone.querySelector('[data-behavior="text"]');
      var tagHiddenField = templateClone.querySelector('[data-behavior="hidden-field"]');
      tagField === null || tagField === void 0 ? void 0 : tagField.setAttribute('value', value);
      tagField === null || tagField === void 0 ? void 0 : tagField.toggleAttribute('data-persisted', persisted);
      if (tagText) tagText.innerText = text;
      if (tagHiddenField) tagHiddenField.value = value;
      this.autocomplete.control.insertBefore(templateClone, this.template);
    }
  }, {
    key: "removeTag",
    value: function removeTag(value) {
      var tag = this.tags.find(function (t) {
        return getValue(t) === value;
      });
      tag === null || tag === void 0 ? void 0 : tag.remove();
    }
  }, {
    key: "updateElementValue",
    value: function updateElementValue() {
      var values = Array.from(this.selectedValues.values());
      this.autocomplete.value = JSON.stringify(values);
    }
  }, {
    key: "clearInputField",
    value: function clearInputField() {
      if (this.autocomplete.input.value) {
        this.autocomplete.input.value = '';
      }
    }
  }, {
    key: "firstActiveOption",
    get: function get() {
      var _this4 = this;

      var option = this.autocomplete.visibleOptions.find(function (option) {
        return _this4.selectedValues.has(getValue(option));
      });
      return option || this.autocomplete.visibleOptions[0];
    }
  }, {
    key: "tags",
    get: function get() {
      return Array.from(this.autocomplete.querySelectorAll('[data-behavior="tag"]'));
    }
  }, {
    key: "persistedTags",
    get: function get() {
      return this.tags.filter(function (tag) {
        return tag.hasAttribute('data-persisted');
      });
    }
  }, {
    key: "template",
    get: function get() {
      return this.autocomplete.querySelector('[data-behavior="tag-template"]');
    }
  }]);

  return MultipleSelect;
}();

function parseJSON(value) {
  try {
    var parsedValue = JSON.parse(value);
    return parsedValue.map(function (e) {
      return e.toString();
    });
  } catch (_a) {
    return [];
  }
}

export { MultipleSelect as default };